const { getElement } = window.BAO.Utils

export class ScrollToTrigger extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    const observer = new MutationObserver(() => {
      const filterCheckbox = getElement('.stockist-search-filters', {
        context: this,
      })

      this.listeners.add(filterCheckbox, 'click', this.handleClick.bind(this))

      observer.disconnect()
    })

    observer.observe(this, {
      childList: true,
      subtree: true,
    })
  }

  handleClick (e) {
    const element = getElement('.stockist-search-filter-checkboxes', {
      context: this,
    })
    element.ariaExpanded = element.ariaExpanded !== 'true'
  }
}

if (!customElements.get('stockist-map')) {
  customElements.define('stockist-map', ScrollToTrigger)
}
